export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10280.bd09d1be.jpg";